import React from "react";

/**
 * Bilgi kartındaki tek bir alan: küçük etiket + büyük değer.
 *
 * Eskiden etiket ve değer YAN YANA duruyor, hizalama sabit piksel
 * genişliklerle (`titleWidth`, `pl-32`) zorlanıyordu; uzun sipariş adları
 * taşıyor, değerler kayıyordu. Artık etiket üstte, değer altta — genişlikten
 * bağımsız hizalanır.
 *
 * `titleWidth` ve `gap` parametreleri geriye dönük uyumluluk için kabul edilir
 * ama KULLANILMAZ; çağrı yerlerini tek tek düzenlemeye gerek kalmasın diye.
 */
export default function CardItem({ data, title, emphasis = false }) {
  const empty = data === undefined || data === null || data === "";

  return (
    <div className="flex min-w-0 flex-col justify-center gap-0.5">
      <span className="truncate text-[12px] font-semibold uppercase tracking-label text-content-muted">
        {title}
      </span>
      <span
        className={[
          "truncate font-bold tabular-nums text-content",
          emphasis ? "text-[26px] leading-tight" : "text-[20px] leading-tight",
        ].join(" ")}
        title={empty ? undefined : String(data)}
      >
        {empty ? "—" : data}
      </span>
    </div>
  );
}
